var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _vm._v(
        "В рамках нахождения в лимитах карты заменены на " +
          _vm._s(_vm.data.owner && _vm.data.owner.short_name) +
          ". Сбербанк"
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm._v(
        _vm._s(_vm.data.type === 1 ? "VISA" : "MASTER") +
          " - " +
          _vm._s(_vm.data.number)
      ),
    ]),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.data.owner && _vm.data.owner.full_name))]),
    _vm._v(" "),
    _c("div", [
      _vm._v("Автописьма изменены, СМС информирование подключено на платформу"),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm._v("Доступ в Сбербанк онлайн:"),
      _c("br"),
      _vm._v(
        "\n    логин - " +
          _vm._s(_vm.data.owner && _vm.data.owner.banking_login)
      ),
      _c("br"),
      _vm._v(
        "\n    пароль - " +
          _vm._s(_vm.data.owner && _vm.data.owner.banking_password) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm._v(
        "Прошлые карты открыты, старые платежи МОГУТ прийти туда, поэтому старым клиентам рассылать информацию об изменении реквизитов НЕ нужно."
      ),
    ]),
    _vm._v(" "),
    _c("div", [_vm._v("Ротация карт будет происходить раз в 10 дней.")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }